import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {BaseRestService} from './base-rest.service';
import {AppSettingsService} from './app-settings.service';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {SharedModule} from '../shared.module';

@Injectable({ providedIn: SharedModule })
export class TestDataService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }

  protected get className(): string {
    return 'TestDataService';
  }

  protected get isAnonymous(): boolean {
    return true;
  }

  geTestData(): Observable<SendBackResult<ArrayResponse<number>>> {
    return of({
      'data': {
        'array': [Math.floor((Math.random() * 10000) + 3), Math.floor((Math.random() * 10000) + 3)],
        'count': 16
      },
      'cached': false,
      'log': null,
      'message': null,
      'statusCode': 0,
      'timeToProcess': '00:00:00.0915196',
      'version': '1.0.1.18'
    })
  }

}
